import { Guid } from '@Shared.Angular/@types/guid';

export interface IStakeholderRef {
  id: Guid;
  name: string;
}

export interface IStakeholderSection {
  users: IStakeholderRef[];
  teams: IStakeholderRef[];
}

export interface IStakeholders {
  responsible: IStakeholderSection | null;
  accountable: IStakeholderSection | null;
  consulted: IStakeholderSection | null;
  informed: IStakeholderSection | null;
}

export const emptyStakeholderSection = (): IStakeholderSection => ({
  users: [],
  teams: []
});

export const emptyStakeholders = (): IStakeholders => ({
  responsible: emptyStakeholderSection(),
  accountable: emptyStakeholderSection(),
  consulted: emptyStakeholderSection(),
  informed: emptyStakeholderSection()
});
